import {useUniWebTemplate} from "~/composables/useUniWebTemplate"
import type SurveyPayload from "~/services/SurveyService/interfaces/SurveyPayload"

export const useSurvey = () => {
  const logger = useFrontendLogger()

  const submitSurvey = async (payload: SurveyPayload) => {
    const template = useUniWebTemplate().uniWebTemplateNameLowerCase
    const url = `/survey/${template}`
    if (import.meta.client) {
      try {
        const { data, status, error, refresh, clear } = await useFetch(url, {
          method: 'POST',
          body: payload,
        })

        if (status.value === 'error') {
          logger?.error('useSurvey:submitSurvey:client - error', {
            template,
            surveyPayload: payload,
            errorDetail: {
              data: error.value?.data,
              name: error.value?.name,
              message: error.value?.message
            },
          })
          return {
            status: status.value,
            statusCode: error.value?.statusCode,
            errors: error.value?.data?.errors
          }
        }
        return {
          status: status.value,
          data: data.value,
        }
      } catch (e) {
        logger?.error('useSurvey:submitSurvey:client - exception', {
          errorDetail: e,
          addDetailViewUrl: url,
        })
        return {
          status: 'error',
          data: e
        }
      }
    }
    return {
      status: 'not_supported'
    }
  }

  const isSurveySubmitted = (id: string):boolean => {
    return false
    // NO COOKIE CHECK - check is done after submit on server side
    // const survey = useCookie(`cnc_survey.${id}`)
    // return survey.value == "1"
  }

  const setSurveySubmitted = (id: string):boolean => {
    return true
    // NO COOKIE CHECK - check is done after submit on server side
    // const survey = useCookie(`cnc_survey.${id}`)
    // survey.value = "1"
    // return true
  }

  return {
    submitSurvey,
    isSurveySubmitted,
    setSurveySubmitted
  }
}


